module.exports = __webpack_public_path__ + "img/Arrow_Left.5b06def1.svg";